import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=3aba75d0&scoped=true&"
import script from "./AddNews.vue?vue&type=script&lang=js&"
export * from "./AddNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba75d0",
  null
  
)

export default component.exports